import m from 'mithril'
import {t} from 'store'
import {Component, Image, classes} from '@codeurs/front'
import Logo from 'assets/images/smeunited-logo-white.svg'

import './publicationimage.less'

export default class PublicationImage extends Component<{
	publication_subtitle: string
	publication_title: string
	label: Array<string>
	featured: boolean
	hasClass?: string
}> {
	view() {
		const {
			publication_subtitle,
			publication_title,
			label,
			featured = true,
			hasClass
		} = this.attrs

		const mods = this.getMod(label, featured).join(' ')
		return m('.publicationimage', {class: mods + ' ' + hasClass}, [
			m(Image, {
				...classes('publicationimage-logo', mods),
				src: Logo,
				alt: 'SMEUnited logo'
			}),
			m('.publicationimage-leftline'),
			m('.publicationimage-pieceofpaper'),
			m('.publicationimage-gradient'),
			m('.publicationimage-squares', [
				m('.publicationimage-squares-square1.publicationimage-squares-square', {
					class: mods
				}),
				m('.publicationimage-squares-square2.publicationimage-squares-square', {
					class: mods
				})
			]),
			m('.publicationimage-titles', [
				publication_title && this.setTitle(publication_title, featured),
				publication_subtitle &&
					m('h4.publicationimage-titles-subtitle',
						{class: mods},
						publication_subtitle
					)
			])
		])
	}
	getMod(label: Array<string>, featured: boolean): Array<string> {
		const mods = []
		if (label) if (label[0] == 'paper') mods.push('mod-blue')
		if (featured) mods.push('mod-big')
		return mods
	}
	setTitle(publication_title: string, featured: Boolean) {
		const count = publication_title.length
		let fontsize = 12
		if (featured && window.matchMedia('(min-width: 1280px').matches) {
			if (count < 70) fontsize = 20
			if (count < 40) fontsize = 25
			if (count < 20) fontsize = 30
		} else {
			if (count < 60) fontsize = 10
			if (count < 40) fontsize = 15
			if (count < 20) fontsize = 20
		}
		return m('h3.publicationimage-titles-title',
			{
				style: `font-size: ${fontsize}px; line-height: ${fontsize + 6}px;`
			},
			publication_title
		)
	}
}
